// extracted by mini-css-extract-plugin
export default {"inputWithSuffix":"AssignmentEdit_inputWithSuffix__G7Mkr","flexContainer":"AssignmentEdit_flexContainer__eq1qF","tag":"AssignmentEdit_tag__+P0SP"};